<template>
    <div class="cart" id="card">
        <PageIntro title="Orçamento" :notbarproduct="true"/>
        <div class="container">
            <div class="breadcrumb">
                <router-link class="breadcrumb__link" to="/">Home</router-link>
                <router-link class="breadcrumb__link" :to="`/produtos/${firstProduct}`">Produtos</router-link>
                <router-link class="breadcrumb__link" to="/quotelist">Orçamento</router-link>
            </div>
        </div>
        <div class="container">
            <div class="cart-container">
                <h3 class="cart-container__title" v-if="$root.cart.length">Produtos adicionados</h3>
                <div class="product-item" v-for="(product, index) in $root.cart" :key="product.id">
                    <div class="close" @click="removeItem(index)">
                        <img src="@/assets/icons/white-close.svg" alt="">
                    </div>
                    <div class="product">
                        <div class="product__img">
                            <lazy-image :image="product.images[0]"/>
                        </div>
                        <div class="product__info">
                            <h2 class="product__info__title">{{product.name}}</h2>
                            <span class="product__info__ref">Ref: {{product.ref}}</span>
                        </div>
                    </div>
                    <div class="finishes">
                        <h3 class="finishes__title">Acabamentos</h3>
                        <div class="finishes__options" v-if="'opcoes' in product">
                            <div class="ball ball-cart" v-lazy:background-image="option"
                                 v-for="option in product.opcoesImg" :key="option.id"></div>
                        </div>
                    </div>
                    <div class="obs">
                        <h3 class="obs__title">Observação</h3>
                        <p class="obs__text">{{product.description}}</p>
                    </div>
                    <div class="quantity">
                        <h3 class="quantity__title">Quantidades</h3>
                        <div class="quantity__panel">
                            <input ref="item" :value="$root.cart[index].quantity" @input="updateQuantity"
                                   :data-index="index" type="text" class="quantity__panel__number">
                            <div class="controls">
                                <span @click="oneMore(index)" class="add"><img src="@/assets/icons/arrow-cart.svg"
                                                                               alt=""></span>
                                <span @click="oneLess(index)" class="remove">
                                    <img src="@/assets/icons/arrow-cart.svg" alt=""></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ContactCart @cleanCart="cleanProducts"/>
        <ModalConfirm :msg="msg" :show="show"/>
    </div>
</template>

<script>
    import PageIntro from "../components/Shared/PageIntro";
    import ContactCart from "../components/Cart/ContactCart";
    import ModalConfirm from "../components/Shared/ModalConfirm";
    import LazyImage from "../components/Shared/LazyImage";

    export default {
        name: "Cart",
        data() {
            return {
                msg: '',
                show: false,
                firstProduct: null,
            }
        },
        methods: {
            updateQuantity(event) {
                const index = event.target.dataset.index;
                let newVal = parseInt(event.target.value);

                if (isNaN(newVal)) {
                    newVal = 1;
                }

                this.$root.setQuantity(index, newVal);
            },
            cleanProducts() {
                this.products = [];
                window.localStorage.cart = [];
                this.$root.cart = [];
                this.$root.number = 0;
            },
            removeItem(index) {
                this.$root.removeProduct(index);

                this.msg = 'Produto removido do carrinho';
                this.show = true;
                setTimeout(() => {
                    this.show = false;
                }, 1000);
            },
            oneMore(index) {
                this.$root.increaseQuantity(index);
            },
            oneLess(index) {
                this.$root.decreaseQuantity(index);
            }
        },
        mounted() {
            document.title = 'Fibrillare - Carrinho';
            axios.get('/categories')
                .then(r => {
                    this.firstProduct = r.data[0].url || r.data[0].id;
                });
        },
        components: {
            PageIntro,
            ContactCart,
            ModalConfirm,
            LazyImage
        }
    }
</script>

<style lang="scss" scoped>
    .cart-container__title {
        font-size: 2rem;
        font-family: HelveticaNeue, Arial, sans-serif;
        font-weight: 500;
        margin-bottom: 40px;
    }

    .product-item {
        display: flex;
        align-items: center;
        border: 1px solid #e5e5e5;
        padding: 20px 40px;
        margin-bottom: 30px;
    }

    .close {
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        margin-right: 10px;
        background: #f2593f;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 12px;
            height: 12px;
        }

        &:hover {
            cursor: pointer;
        }
    }

    .product {
        display: flex;
        align-items: center;
        padding-right: 40px;
        border-right: 1px solid #e5e5e5;

        &__img {
            width: 90px;
            flex-shrink: 0;
            height: 85px;
            overflow: hidden;
            margin-right: 30px;

            img {
                margin-top: 10px;
            }
        }
    }

    .product__info {
        &__title {
            max-width: 120px;
            font-family: "Open Sans", sans-serif;
            color: #2b2b2b;
            font-size: 0.875rem;
        }

        &__ref {
            font-family: "Open Sans", sans-serif;
            color: #2b2b2b;
            font-size: 0.875rem;
        }
    }

    .finishes {
        width: 260px;
        flex-shrink: 0;
        height: 85px;
        padding: 0 40px;
        border-right: 1px solid #e5e5e5;

        &__title {
            font-size: 0.75rem;
            font-family: "Open Sans", sans-serif;
            color: #2b2b2b;
            margin-bottom: 10px;
        }

        &__options {
            display: flex;
            justify-content: space-around;
        }
    }

    .obs {
        width: 340px;
        height: 90px;
        overflow: auto;
        padding: 0 40px;
        border-right: 1px solid #e5e5e5;

        &__title {
            font-size: 0.75rem;
            color: #2b2b2b;
            font-family: "Open Sans";
            font-weight: 700;
            margin-bottom: 5px;
        }

        &__text {
            font-size: 0.75rem;
            color: #2b2b2b;
            font-family: "Open Sans";
            font-weight: 300;
        }
    }

    .ball-cart {
        width: 50px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        height: 50px;
    }

    .quantity {
        height: 85px;
        padding: 0 40px;

        &__title {
            font-size: 0.75rem;
            color: #2b2b2b;
            font-family: "Open Sans";
            font-weight: 700;
            margin-bottom: 15px;
            text-align: center;
        }

        &__panel {
            position: relative;

            &__number {
                display: block;
                width: 58px;
                padding-left: 10px;
                border-radius: 4px;
                height: 40px;
                border: 1px solid #e5e5e5;
                font-family: "Open Sans";
                color: #b3b3b3;
                font-size: 0.75rem;
            }
        }


    }

    .controls {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-left: 1px solid;
        border-color: #e5e5e5;
        position: absolute;
        width: 20px;
        height: 100%;
        /*background: tomato;*/
        right: 16px;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .add {
        height: 18px;
        width: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-right: 2px;
        margin-top: 2px;

        &:hover {
            background: #e5e5e5;
        }

        img {

        }
    }

    .remove {
        margin-top: 2px;
        height: 18px;
        width: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: rotate(180deg);
        cursor: pointer;

        &:hover {
            background: #e5e5e5;
        }
    }

    @media only screen and (max-width: 1023px) {
        .product-item {
            padding: 15px;
        }

        .close {
            margin-right: 10px;
        }

        .quantity {
            padding: 0 12px;
        }

        .product, .finishes, .obs {
            padding: 0 12px;
        }

        .cart-container__title {
            font-size: 1.5rem;
        }

        .product__info__title {
            max-width: 200px;
            text-align: center;
            font-size: 0.875rem;
        }

        .product__info__ref {
            font-size: 0.75rem;
        }
    }

    @media only screen and (max-width: 767px) {
        .breadcrumb {
            padding-top: 0px;
        }

        .product-item {
            flex-direction: column;
            justify-content: flex-start;
        }

        .product, .finishes, .obs {
            border: none;
            padding: 10px 0;
            width: 100%;
            margin: 5px 0;
        }

        .obs {
            margin-top: 10px;
            padding-top: 0;
            padding-bottom: 0;
            padding-right: 10px;
        }

        .product {
            margin: 10px 0 5px 0;
            flex-direction: column;
            /*align-items: flex-start;*/
            padding: 15px 0 0 0;
        }

        .product__img {
            margin-right: 0;
            margin-bottom: 5px;
        }

        .quantity {
            align-self: flex-start;
            margin: 10px 0 0 0;
            padding: 0;

            &__title {
                margin-bottom: 10px;
            }
        }

        .close {
            position: absolute;
            right: 15px;
        }

        .add:hover {
            background: transparent;
        }

        .remove:hover {
            background: transparent;
        }
    }
</style>